import { useHasAnyCoreSeatsInProductDetails, useHasAnySuiteBundlesInProductDetails } from '../v2/hooks/useProductDetails';
import { useIsSeatsUser } from '../v2/hooks/useUserInfo';
import { useGlobalLoading } from './loadingHooks';
import { usePurchaseableProductsForApiName } from './useBulkPurchaseOptions';
export const useMismatchedCohortingCheck = () => {
  const isAppReady = useGlobalLoading();
  const hasSeatsAccessScope = useIsSeatsUser();
  const {
    hasAnyCoreSeats: hasAnyCoreSeatsInProductData,
    loading: isCoreSeatsProductDataLoading
  } = useHasAnyCoreSeatsInProductDetails();
  const {
    hasAnySuiteBundles: hasAnySuiteBundlesInProductData,
    loading: isSuiteBundlesProductDataLoading
  } = useHasAnySuiteBundlesInProductDetails();
  const {
    purchaseOptionsForApiName: purchaseOptionsForCoreSeatsStarter,
    loading: isCoreSeatsStarterInPopDataLoading,
    error: isCoreSeatsStarterInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: 'core-seats-starter'
  });
  const hasCoreSeatsStarterInPopData = !isCoreSeatsStarterInPopDataLoading && !isCoreSeatsStarterInPopDataError && !!(purchaseOptionsForCoreSeatsStarter !== null && purchaseOptionsForCoreSeatsStarter !== void 0 && purchaseOptionsForCoreSeatsStarter.length);
  const {
    purchaseOptionsForApiName: purchaseOptionsForCoreSeatsProfessional,
    loading: isCoreSeatsProfessionalInPopDataLoading,
    error: isCoreSeatsProfessionalInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: 'core-seats-professional'
  });
  const hasCoreSeatsProfessionalInPopData = !isCoreSeatsProfessionalInPopDataLoading && !isCoreSeatsProfessionalInPopDataError && !!(purchaseOptionsForCoreSeatsProfessional !== null && purchaseOptionsForCoreSeatsProfessional !== void 0 && purchaseOptionsForCoreSeatsProfessional.length);
  const {
    purchaseOptionsForApiName: purchaseOptionsForCoreSeatsEnterprise,
    loading: isCoreSeatsEnterpriseInPopDataLoading,
    error: isCoreSeatsEnterpriseInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: 'core-seats-enterprise'
  });
  const hasCoreSeatsEnterpriseInPopData = !isCoreSeatsEnterpriseInPopDataLoading && !isCoreSeatsEnterpriseInPopDataError && !!(purchaseOptionsForCoreSeatsEnterprise !== null && purchaseOptionsForCoreSeatsEnterprise !== void 0 && purchaseOptionsForCoreSeatsEnterprise.length);
  const hasAnyCoreSeatsProductsInPopData = hasCoreSeatsStarterInPopData || hasCoreSeatsProfessionalInPopData || hasCoreSeatsEnterpriseInPopData;
  const {
    purchaseOptionsForApiName: purchaseOptionsForCrmSuiteStarter,
    loading: isCrmSuiteStarterInPopDataLoading,
    error: isCrmSuiteStarterInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: 'crm-suite-starter-bundle'
  });
  const hasCrmSuiteStarterInPopData = !isCrmSuiteStarterInPopDataLoading && !isCrmSuiteStarterInPopDataError && !!(purchaseOptionsForCrmSuiteStarter !== null && purchaseOptionsForCrmSuiteStarter !== void 0 && purchaseOptionsForCrmSuiteStarter.length);
  const {
    purchaseOptionsForApiName: purchaseOptionsForCrmSuiteProfessional,
    loading: isCrmSuiteProfessionalInPopDataLoading,
    error: isCrmSuiteProfessionalInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: 'crm-suite-professional-bundle'
  });
  const hasCrmSuiteProfessionalInPopData = !isCrmSuiteProfessionalInPopDataLoading && !isCrmSuiteProfessionalInPopDataError && !!(purchaseOptionsForCrmSuiteProfessional !== null && purchaseOptionsForCrmSuiteProfessional !== void 0 && purchaseOptionsForCrmSuiteProfessional.length);
  const {
    purchaseOptionsForApiName: purchaseOptionsForCrmSuiteEnterprise,
    loading: isCrmSuiteEnterpriseInPopDataLoading,
    error: isCrmSuiteEnterpriseInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: 'crm-suite-enterprise-bundle'
  });
  const hasCrmSuiteEnterpriseInPopData = !isCrmSuiteEnterpriseInPopDataLoading && !isCrmSuiteEnterpriseInPopDataError && !!(purchaseOptionsForCrmSuiteEnterprise !== null && purchaseOptionsForCrmSuiteEnterprise !== void 0 && purchaseOptionsForCrmSuiteEnterprise.length);
  const hasAnySuiteBundleProductsInPopData = hasCrmSuiteStarterInPopData || hasCrmSuiteProfessionalInPopData || hasCrmSuiteEnterpriseInPopData;
  const isSeatsLoading = isCoreSeatsProductDataLoading || isCoreSeatsStarterInPopDataLoading || isCoreSeatsProfessionalInPopDataLoading || isCoreSeatsEnterpriseInPopDataLoading;
  const isSuiteBundlesLoading = isSuiteBundlesProductDataLoading || isCrmSuiteStarterInPopDataLoading || isCrmSuiteProfessionalInPopDataLoading || isCrmSuiteEnterpriseInPopDataLoading;
  const isLoading = !isAppReady || isSeatsLoading || isSuiteBundlesLoading;
  const preSeatsCohort = !hasAnyCoreSeatsProductsInPopData && !hasAnyCoreSeatsInProductData && !hasSeatsAccessScope;
  const seatsCohort = hasSeatsAccessScope && hasAnyCoreSeatsInProductData && hasAnyCoreSeatsProductsInPopData;
  const hasMismatchedProductsAndPopData = hasAnySuiteBundlesInProductData !== hasAnySuiteBundleProductsInPopData || hasAnyCoreSeatsInProductData !== hasAnyCoreSeatsProductsInPopData;
  const hasMismatchedSeatsGating = !(preSeatsCohort || seatsCohort);
  return {
    loading: isLoading,
    hasMismatchedProductsAndPopData,
    hasMismatchedSeatsGating
  };
};